import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = null;

export const serviceTokenSlice = createSlice({
 name: 'serviceToken',
 initialState,
 reducers: {
  serviceToken: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { serviceToken } = serviceTokenSlice.actions;

export default serviceTokenSlice.reducer;
